var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Svg, { Path } from 'react-native-svg';
import { checkIsPlatform } from '../../utils';
var SvgLoaderIcon = props => {
  var accessibilityLabelKey = checkIsPlatform('web') ? 'aria-label' : 'accessibilityLabel';
  var _props = props,
    _props$fontSize = _props.fontSize,
    fontSize = _props$fontSize === void 0 ? 24 : _props$fontSize,
    _props$color = _props.color,
    color = _props$color === void 0 ? '#292C31' : _props$color,
    testID = _props.testID,
    accessibilityLabel = _props.accessibilityLabel,
    restProps = __rest(props, ["fontSize", "color", "testID", "accessibilityLabel"]);
  props = Object.assign(Object.assign({
    fontSize,
    color,
    id: testID
  }, restProps), accessibilityLabel && {
    [accessibilityLabelKey]: accessibilityLabel
  });
  return _jsx(Svg, Object.assign({
    width: fontSize,
    height: fontSize,
    fill: "none",
    viewBox: "0 0 47 46"
  }, props, {
    children: _jsx(Path, {
      fill: color,
      fillRule: "evenodd",
      d: "M23.5 3.708c-2.562 0-5.003.498-7.234 1.402a19.372 19.372 0 0 0-9.918 9.05A19.203 19.203 0 0 0 4.208 23c0 10.655 8.637 19.292 19.292 19.292 10.655 0 19.292-8.637 19.292-19.292 0-6.453-3.167-12.167-8.04-15.672a1.754 1.754 0 1 1 2.05-2.848C42.55 8.616 46.3 15.37 46.3 23c0 12.592-10.208 22.8-22.8 22.8S.7 35.592.7 23c0-3.763.913-7.318 2.531-10.45A22.879 22.879 0 0 1 14.95 1.857 22.74 22.74 0 0 1 23.5.2a1.754 1.754 0 0 1 0 3.508Z",
      clipRule: "evenodd"
    })
  }));
};
export default SvgLoaderIcon;